import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import { axiosHttpRes, axiosHttp } from './interceptors';

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
axiosHttp()
axiosHttpRes()

import lang from 'element-ui/lib/locale/lang/pt-br';
import locale from 'element-ui/lib/locale';

// configure language
locale.use(lang);

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import {
   Autocomplete,
   Button,
   FormItem,
   Select,
   Form,
   Dialog,
   Rate,
   Image,
   Link,
   Input,
   Checkbox,
   Option,
   Collapse,
   CollapseItem,
   Card,
   Calendar,
   Carousel,
   CarouselItem,
   Avatar,
   Tooltip,
   Col,
   Row,
   Step,
   Steps,
   Table,
   TableColumn,
   Tag,
   TabPane,
   Tabs,
   Drawer,
   Timeline,
   TimelineItem,
   MessageBox,
   Alert,
   Notification,
   Upload,
   Popconfirm,
   Radio,
   RadioGroup,
   Message,
   ButtonGroup,
   Badge,
   Loading,
   Popover,
   Pagination,
   Menu,
   Submenu,
   MenuItem,
   MenuItemGroup,
   Divider,
   Progress,
   TimeSelect,
   InputNumber,
   Switch,
   DatePicker

} from 'element-ui';
Vue.use(Autocomplete); Vue.use(Button); Vue.use(FormItem); Vue.use(Select); Vue.use(Form); Vue.use(Dialog); Vue.use(Rate); Vue.use(Image); Vue.use(Link); Vue.use(Input); Vue.use(Checkbox); Vue.use(Option); Vue.use(Collapse); Vue.use(CollapseItem); Vue.use(Card); Vue.use(Calendar); Vue.use(Carousel); Vue.use(CarouselItem); Vue.use(Avatar); Vue.use(Tooltip); Vue.use(Col); Vue.use(Row); Vue.use(Step); Vue.use(Steps); Vue.use(Table); Vue.use(TableColumn); Vue.use(Tag); Vue.use(Tabs); Vue.use(TabPane); Vue.use(Drawer); Vue.use(Timeline); Vue.use(TimelineItem); Vue.use(Alert); Vue.use(Upload); Vue.use(Popconfirm); Vue.use(Radio); Vue.use(RadioGroup); Vue.use(ButtonGroup); Vue.use(Badge); Vue.use(Popover); Vue.use(Pagination); Vue.use(Menu);Vue.use(Submenu);Vue.use(MenuItem); Vue.use(MenuItemGroup); Vue.use(Divider); Vue.use(Progress); Vue.use(TimeSelect); Vue.use(InputNumber); Vue.use(Switch); Vue.use(DatePicker)

Vue.use(Loading.directive);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;


import './assets/styles/main.scss'

//import 'vue-awesome/icons'

import 'vue-awesome/icons/user'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/brands/facebook-f'
import 'vue-awesome/icons/brands/facebook'
import 'vue-awesome/icons/brands/facebook-square'
import 'vue-awesome/icons/brands/instagram'
import 'vue-awesome/icons/brands/twitter'
import 'vue-awesome/icons/brands/whatsapp'
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/exclamation-circle'
import 'vue-awesome/icons/calendar-alt'
import 'vue-awesome/icons/question-circle'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/comments'
import 'vue-awesome/icons/file-alt'
import 'vue-awesome/icons/dollar-sign'
import 'vue-awesome/icons/donate'
import 'vue-awesome/icons/hand-holding-usd'
import 'vue-awesome/icons/paper-plane'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/hourglass-half'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/calendar-times'
import 'vue-awesome/icons/calendar-check'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/bars'

import Icon from 'vue-awesome/components/Icon.vue'
Vue.component('v-icon', Icon);

import { LayoutPlugin } from 'bootstrap-vue'
Vue.use(LayoutPlugin)

import money from 'v-money'
Vue.use(money);

import vueNumeralFilterInstaller from 'vue-numeral-filter';
Vue.use(vueNumeralFilterInstaller,{
  locale: 'pt-br',
});

import moment from 'moment';
require('moment/locale/pt-br');
import VueMoment from 'vue-moment'

Vue.use(VueMoment, {
  moment
});

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCL4eqDSnQ_RI9PT8SexYJvsA_YHY6pKKA',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

Vue.config.productionTip = false;

Vue.prototype.$appName = 'Pedale';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
